/*
 * Copyright (c) 2021 biocrates life sciences ag, All rights reserved.
 */

import React from "react"

import {Button, Intent} from "@blueprintjs/core"

import "./Button.css"
import {useTranslation} from "react-i18next"

import MinimalButtonProps from "./buttonProps"

const ActionButton: React.FC<MinimalButtonProps> = (props) => {
    const {t} = useTranslation()
    return (
        <Button
            intent={Intent.DANGER}
            icon={props.icon}
            text={props.text ? t(props.text) : props.text}
            onClick={props.onClick}
            rightIcon={props.rightIcon}
            style={props.style}
            disabled={props.disabled}
            active={props.active}
            alignText={props.alignText}
            className={`action-button ${props.className}`}
            id={props.id}
        />
    )
}

export default ActionButton
